let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("deyvi")).then(() => parcelRequire('e3sAb'));